module.exports = __webpack_public_path__ + "img/contrato_flexmulti.25affbda.jpg";